import Client from "./clients/rest";

export default {

  getReports(businessId, pageNumber, object, excel) {
    const query = new URLSearchParams(JSON.parse(JSON.stringify(object, (k, v) => v ?? undefined))).toString()
    return Client.get(`business/${businessId}/orders_online?siebelIds=${businessId}&pageNumber=${pageNumber}
        &pageSize=${10}${query ? '&' + query : ""}${excel ? '&isExportMode=true' : ""} `);
  },

  getOrdersSummary(businessId, fromDate, toDate) {
    return Client.get(`business/${businessId}/orders_online_summary?SiebelIds=${businessId}&fromDate=${fromDate}&toDate=${toDate}`);
  },

  orderDetails(businessId, id) {
    return Client.get(`business/${businessId}/order_details?id=${id}`)
  },

  refundOrder(businessId, orderId, refundAmount, description) {
    return Client.post(`business/${businessId}/order_refunds`, {
      sibleId: businessId,
      orderId,
      refundAmount,
      description
    });
  }
};
